<!-- eslint-disable max-len -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
      <v-toolbar flat outlined>
        <v-btn icon :link="false" @click="back">
          <v-icon>fa-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
        <v-spacer/>
        <v-btn color="primary" @click="send_form">
          Guardar
        </v-btn>
      </v-toolbar>
      <v-container grid-list-md fluid>
        <v-alert
          :value="alertDialog"
          :type="alertDialogType"
          outline
        >
          {{ alertDialogMessage }}
        </v-alert>
        <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
        <v-layout row wrap>
          <v-flex xs12 sm3 md3 style="display: none">
            <v-text-field
              disabled
              v-model="licencia_id"
              label="id"
            />
          </v-flex>
          <template v-if="editlicencia===true">
            <v-flex xs12 sm1 md1>
              <v-text-field
                v-model="folio"
                label="Folio"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm3 md3>
              <v-text-field
                v-model="vivienda"
                label="Vivienda"
                readonly
              />
            </v-flex>
            <v-flex xs12 s2 md2>
              <v-text-field
                v-model="tipo"
                label="Tipo"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-text-field
                v-model="nombre"
                label="Nombre Completo"
                readonly
              />
            </v-flex>
          </template>
          <template v-else>
            <v-flex xs12 sm3 md3>
                <v-combobox
                  v-model="vivienda_asoc"
                  label="Vivienda"
                  placeholder="Comience a escribir para buscar"
                  :items="viviendas"
                  :loading="viviendaIsLoading"
                  :search-input.sync="viviendaSearch"
                  :hide-no-data="!viviendaSearch"
                  item-text="n_vivienda"
                  item-value="n_vivienda"
                  return-object
                  @change="vivienda_asoc_change($event)"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-select
                  v-model="tipo"
                  label="Tipo"
                  placeholder = "Seleccione un tipo"
                  :items="tipo_propietario"
                  :disabled="tipo_disabled"
                  @change="tipo_conductor_change($event)"
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-select
                  v-model="conductor_asoc"
                  label="Conductor"
                  placeholder = "Seleccione un conductor"
                  no-data-text = "Sin información"
                  :disabled="conductor_disabled"
                  :items="conductores"
                />
              </v-flex>
          </template>
          <FechaPicker
            v-model="vigencia"
            label="Vigente Hasta"
            :birthdayPicker="false"
            :size="'2'"
            :min_date="new Date().toISOString().substr(0, 10)"
          >
          </FechaPicker>
        </v-layout>
        </v-form>
        </v-flex>
        </v-layout>
      </v-container>
    </div>
  </template>
<script>
import FechaPicker from '@/components/fecha_picker.vue';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

export default {
  components: {
    FechaPicker,
  },
  data: () => ({
    editlicencia: false,
    licencia_info: {},
    valid: true,
    processing: false,
    licencia_id: '',
    folio: '',
    tipo: '',
    vivienda: '',
    nombre: '',
    vivienda_asoc: null,
    conductor_asoc: null,
    conductoresApiResult: [],
    tipo_disabled: true,
    conductor_disabled: true,
    tipo_propietario: [
      { text: 'Residente', value: 'residente' },
      // { text: 'Socio', value: 'socio' },
      { text: 'Servicio Doméstico', value: 'servicio_domestico' },
      // { text: 'Colaborador', value: 'colaborador' },
    ],
    viviendaIsLoading: false,
    viviendaSearch: null,
    viviendasApiResult: [],
    viviendaValid: false,
    vigencia: '',
  }),
  computed: {
    alertType() {
      return this.$store.getters['capturaLicencias/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['capturaLicencias/alertContainerMessage'];
    },
    alert() {
      return this.$store.getters['capturaLicencias/alertContainer'];
    },
    alertDialogType() {
      return this.$store.getters['capturaLicencias/alertDialogType'];
    },
    alertDialogMessage() {
      return this.$store.getters['capturaLicencias/alertDialogMessage'];
    },
    alertDialog() {
      return this.$store.getters['capturaLicencias/alertDialog'];
    },
    formTitle() {
      return this.editlicencia === false ? 'Agregar Licencia' : 'Editar Licencia';
    },
    is_loading() {
      return this.$store.getters['capturaLicencias/is_loading'];
    },
    licencia_processing() {
      return this.$store.getters['capturaLicencias/licencia_processing'];
    },
    viviendas() {
      return this.viviendasApiResult;
    },
    conductores() {
      return this.conductoresApiResult;
    },
  },
  watch: {
    licencia_processing(val) {
      this.processing = val;
    },
    viviendaSearch() {
      if (this.viviendas.length > 0) return;
      if (this.viviendaIsLoading) return;
      this.viviendaIsLoading = true;
      ApiService.setHeader();
      ApiService.query('accesos/viviendas')
        .then(({ data }) => {
          this.viviendasApiResult = data.viviendas;
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.viviendaIsLoading = false;
        });
    },
  },
  methods: {
    back() {
      this.$router.back();
    },
    clear_null(value) {
      let tmpNull = null;
      if (typeof value === 'string') {
        if (value === 'None') {
          tmpNull = '';
        } else {
          tmpNull = value.trim();
        }
      } else if (value === null || typeof value === 'undefined') {
        tmpNull = '';
      } else {
        tmpNull = value;
      }
      return tmpNull;
    },
    init_edit_data(data) {
      // console.log(data);
      this.licencia_id = data.id;
      this.folio = data.folio;
      this.vivienda = data.n_vivienda;
      this.nombre = data.nombre_conductor;
      this.vigencia = data.vigencia;
      if (data.domestico_id !== null) {
        this.tipo = 'Servicio Doméstico';
      } else if (data.residente_id !== null) {
        this.tipo = 'Residente';
      }
    },
    send_form() {
      if (this.processing === true) {
        return;
      }
      if (this.$refs.form.validate()) {
        this.$store.commit('capturaLicencias/startedLicenciaProcessing');
        const formdata = new FormData();
        formdata.set('vigencia', this.clear_null(this.vigencia));
        if (this.editlicencia) {
          formdata.set('licencia_id', this.licencia_id);
        } else {
          formdata.set('residente_id', '');
          formdata.set('domestico_id', '');
          if (this.tipo === 'residente') {
            formdata.set('residente_id', this.conductor_asoc);
          } else if (this.tipo === 'servicio_domestico') {
            formdata.set('domestico_id', this.conductor_asoc);
          }
          formdata.set('vivienda_id', this.vivienda_asoc.id);
          formdata.set('tipo', this.clear_null(this.tipo));
        }
        // console.log(Object.fromEntries(formdata));
        // this.$store.commit('capturaLicencias/resetLicenciaSubmit');
        if (this.editlicencia) {
          this.$store.dispatch('capturaLicencias/editLicencia', formdata).then(() => {
            this.$router.back();
          });
        } else {
          this.$store.dispatch('capturaLicencias/sendLicencia', formdata).then(() => {
            this.$router.back();
          });
        }
      }
    },
    vivienda_asoc_change(event) {
      console.log('vivienda_asoc_change');
      this.tipo = '';
      this.tipo_disabled = false;
      this.conductor_disabled = true;
      this.residenteIsLoading = true;
      this.conductoresApiResult = [];
      this.tmpConductoresApiResult = [];
      if (typeof event === 'object' && this.clear_null(event) !== '') {
        // console.log(event.id !== undefined);
        ApiService.setHeader();
        ApiService.query(`accesos/viviendas/${event.id}`)
          .then(({ data }) => {
            if (data.vivienda.residentes.length > 0 || data.vivienda.domesticos.length > 0) {
              if (data.vivienda.residentes.length > 0) {
              // this.tmpConductoresApiResult.push({ residentes: data.vivienda.residentes });
                this.tmpConductoresApiResult.residentes = data.vivienda.residentes;
              }
              if (data.vivienda.domesticos.length > 0) {
              // this.tmpConductoresApiResult.push({ domesticos: data.vivienda.domesticos });
                this.tmpConductoresApiResult.domesticos = data.vivienda.domesticos;
              }
            } else {
              console.log(data.vivienda);
            }
            console.log(this.tmpConductoresApiResult);
          })
          .catch(({ response }) => {
            console.log(response);
            this.residente_disabled = true;
          })
          .finally(() => {
            this.residenteIsLoading = false;
          });
      } else {
        this.residente_disabled = true;
      }
    },
    tipo_conductor_change(event) {
      console.log('tipo_conductor_change');
      console.log(event);
      
      this.conductor_disabled = false;
      if (event === 'residente' && this.tmpConductoresApiResult.residentes !== undefined) {
        this.residente_concat_fullname(this.tmpConductoresApiResult.residentes);
      } else if (event === 'servicio_domestico' && this.tmpConductoresApiResult.domesticos !== undefined) {
        this.domestico_concat_fullname(this.tmpConductoresApiResult.domesticos);
      }
    },
    domestico_concat_fullname(info) {
      console.log('domestico_concat_fullname');
      this.conductoresApiResult = [];
      info.map((value) => {
        this.conductoresApiResult.push({
          text: `${value.nombres} ${this.clear_null(value.apellido_paterno)} ${this.clear_null(value.apellido_materno)}`.trim(),
          value: value.id,
        });
      });
      this.conductor_asoc = this.conductoresApiResult[0].value;
      this.conductor_fullname_asoc = this.conductoresApiResult[0].text;
    },
    residente_concat_fullname(info) {
      console.log('residente_concat_fullname');
      this.conductoresApiResult = [];
      info.map((value) => {
        this.conductoresApiResult.push({
          text: `${value.residente.nombres} ${this.clear_null(value.residente.apellido_paterno)} ${this.clear_null(value.residente.apellido_materno)}`.trim(),
          value: value.residente_id,
        });
      });
      this.conductor_asoc = this.conductoresApiResult[0].value;
      this.conductor_fullname_asoc = this.conductoresApiResult[0].text;
    },
  },
  created() {

  },
  mounted() {
    if ('id' in this.$route.params) {
      this.$store.dispatch('capturaLicencias/fetchLicenciaInfo', this.$route.params.id).then((data) => {
        this.init_edit_data(data.licencia);
      });
      this.editlicencia = true;
    }
  },
};
</script>
